import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

import { _getKey, checkUserType } from '@utils/Util';

export const fetchSampleRequestByStatus =
	(params = '?page=0&size=15', merge) =>
	async (dispatch) => {
		await ApiClient.GET('fetchSampleRequest', params)
			.then((response) => {
				dispatch({
					type: Types.FETCH_ALL_SAMPLE_BY_STATUS,
					payload: { data: response.data, merge: merge }
				});
				return response;
			})
			.catch((err) => {
				return err;
			});
	};

export const setSampleRequestFilterField = (params) => async (dispatch) => {
	await dispatch({
		type: Types.SET_SAMPLE_REQUEST_FILTER_DATA,
		payload: params
	});
};

export const setReadSampleRequestComment = (id) => async (dispatch) => {
	await dispatch({
		type: Types.SET_READ_SAMPLE_REQUEST_COMMENT,
		payload: id
	});
};

export const fetchSampleRequestCount = (params) => async (dispatch) => {
	await ApiClient.GET('fetchSampleRequestCount', params).then((response) => {
		dispatch({
			type: Types.SET_SAMPLE_REQUEST_COUNT,
			payload: response.data
		});
	});
};

const setColorResponse = (colorList) => {
	let list = [];
	if (colorList.length === 0) {
		list.push({
			key: _getKey(),
			code: '',
			hexCode: null,
			pantoneColorId: null,
			size: checkUserType('FASHION_DESIGNER') ? 'M' : null,
			quantity: checkUserType('FASHION_DESIGNER') ? 1 : null
		});
	} else {
		list = colorList.map((item) => {
			return {
				...item,
				key: _getKey(),
				size: checkUserType('FASHION_DESIGNER') ? 'M' : null,
				quantity: checkUserType('FASHION_DESIGNER') ? 1 : null
			};
		});
	}
	let listLength = list.length;
	for (let i = listLength; i < 4; i++) {
		list.push({
			key: _getKey(),
			code: '',
			hexCode: null,
			pantoneColorId: null,
			size: null,
			quantity: null
		});
	}
	return list;
};

export const fetchSampleProductList = (ids) => async (dispatch) => {
	await ApiClient.GET('fetchProductResponse', `?ids=${ids}`)
		.then((response) => {
			let items = {
				data: response?.data.map((item) => {
					if (item?.isSet) {
						const updatedSetItem = item.setMemberProducts.map((member) => {
							return {
								...member,
								colorResponseList: setColorResponse(member?.colorResponseList),
								setMember: true,
								isSetId: item?.id,
								setName: item?.name,
								referenceNumber: item?.referenceNumber,
								setMemberProductIds: item?.setMemberProductIds

								// designDocuments: item?.designDocuments
							};
						});
						return {
							setItemsList: updatedSetItem,
							setMemberCount: item?.setMemberProductIds.length,
							...item
						};
					} else {
						return {
							...item,
							colorResponseList: setColorResponse(item?.colorResponseList)
						};
					}
				})
			};
			dispatch({
				type: Types.FETCH_SAMPLE_PRODUCTS,
				payload: items.data
			});
		})
		.catch((err) => {
			return err;
		});
};

export const fetchSampleProductById = (params) => async (dispatch) => {
	let url = params?.url || 'sampleDetailsAction';
	let id = params?.paramsData || params;
	let isRestFormat = params?.url ? true : false;
	await ApiClient.GET(url, id, isRestFormat)
		.then((response) => {
			dispatch({
				type: Types.FETCH_SAMPLE_BY_ID,
				payload: response.data
			});
		})
		.catch((err) => {
			return err;
		});
};

export const setSampleViewFilterField = (params) => async (dispatch) => {
	await dispatch({
		type: Types.SET_SAMPLE_VIEW_FILTER_DATA,
		payload: params
	});
};

export const clearSampleRequest = () => async (dispatch) => {
	await dispatch({
		type: Types.CLEAR_SAMPLE_REQUEST,
		payload: {}
	});
};
